const OfficePageStyles = theme => ({
  card: {
    overflow: 'visible'
  },
  topContainer: {
    margin: '64px 0 20px',
    backgroundColor: 'white',
    [theme.breakpoints.down('xs')]: {
      margin: '56px 0 0',
    },
  },
  imageHeader: {
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
    },
    [theme.breakpoints.up('sm')]: {
      top: theme.spacing.unit / -2,
      left: theme.spacing.unit / -2,
      boxShadow: theme.shadows[5],
      borderRadius: theme.shape.borderRadius,
    },
    minHeight: '400px',
    height: '100%',
    width: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    //backgroundImage: 'url(https://www.bazabiur.pl/media/gallery/bobo-coworking-crown-point/biuro-bobo-coworking-crown-point_12.jpg)',
    backgroundPosition: 'top'
  },
  tabContainer: {
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    marginTop: '20px',
    [theme.breakpoints.down('xs')]: {
      marginTop: '25px',
    },
  },
  tabRoot: {
    textTransform: 'initial',
    color: theme.palette.text.primary
  },
  tabsRoot: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    //borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
  },
  inactive: {
    color: theme.palette.text.secondary
  },
  group: {
    display: 'inline-block',
    boxShadow: theme.shadows[2],
    borderRadius: theme.shape.borderRadius
  },
  groupButton: {
    borderRadius: 0,
    boxShadow: 'none',
    minWidth: '40px',
    '&:first-child': {
      borderRadius: `${theme.shape.borderRadius}px 0 0 ${theme.shape.borderRadius}px`,
    },
    '&:last-child': {
      borderRadius: `0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0`,
    },
  },
  optionTitle: {
    minWidth: '50px'
  },
  appBar: {
    position: 'fixed',
    backgroundColor: '#f5f5f5',
    color: '#414042'
  },
  toolbar: {
    padding: '0'
  },
  cardHeader: {
    fontWeight: '500'
  },
  tabsScrollButtons: {
    flex: '0 0 25px'
  }
});

export default OfficePageStyles;


// WEBPACK FOOTER //
// ./src/styles/OfficePage.js